import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function FootDeviceIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("w-4.5 h-4.5", className)}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.19948 4.88699L2.56452 6.50273C2.31545 6.58957 2.04074 6.45668 1.95399 6.20713L1.60152 5.194C1.51477 4.94467 1.64752 4.66968 1.89682 4.58284L6.58479 2.94846C6.80473 2.87193 7.04723 2.98925 7.12368 3.20942L7.49478 4.27561C7.58153 4.52516 7.44855 4.80016 7.19948 4.88699Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.47105 8.98313C7.02548 8.66932 6.91748 8.04763 7.23096 7.60181L8.25311 6.1477C8.02266 5.83872 7.61761 5.70385 7.24279 5.82885L3.16886 7.18823C2.79908 7.31169 2.54956 7.65795 2.54956 8.04829V14.1687C2.54956 14.6691 2.95505 15.075 3.45517 15.075H3.81663L7.891 9.27895L7.47105 8.98313Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4102 12.5525L16.2017 11.4039C16.1338 11.0309 15.8411 10.7394 15.468 10.6734L13.845 10.3868L12.9639 11.6401C12.6504 12.0859 12.0296 12.194 11.584 11.8802L11.1641 11.5846L8.71058 15.075H11.0348C11.8386 15.075 12.6345 14.9141 13.3753 14.6018L15.8707 13.5501C16.2619 13.3852 16.4863 12.9705 16.4102 12.5525Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3167 8.91339L9.75536 6.40493C9.53959 6.25296 9.23903 6.30537 9.08722 6.52115L8.9457 6.72246L8.15795 7.80729C8.00614 8.02329 8.05849 8.32438 8.27427 8.47635L11.7894 10.9524C12.0051 11.1043 12.3059 11.0519 12.4577 10.8361L13.1123 9.94033L13.4192 9.50372C13.5533 9.31316 13.5071 9.0476 13.3167 8.91339Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50372 9.71051L4.73122 15.075H7.80096L10.5566 11.1565L8.50372 9.71051Z"
        fill="currentColor"
      />
    </svg>
  );
}
